export class Populations {
  public static Guardian = 'Guardian';
  public static Kids = 'Kids';
}